import React, { useEffect, useState, useContext } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { merge } from 'lodash';
import ReactApexChart from 'react-apexcharts';
// material
import { Box, Card, CardHeader, Alert, Typography } from '@mui/material';
//
import { BaseOptionChart } from '../../charts';
// context
import { ReportContext } from '../../../contexts/Report';

// ----------------------------------------------------------------------

export default function AppRegionList() {
  const [chartLabels, setChartLabels] = useState([]);
  const [chartData, setChartData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const {
    sales,
    isLoading: isLoadingRegionSales,
    hasError: hasErrorRegionSales
  } = useContext(ReportContext);

  useEffect(() => {
    const setData = async () => {
      try {
        const chartLabels = sales.paid.locations.map((location) => location._id || '(not set)');
        const chartData = [{ data: sales.paid.locations.map((location) => location.amount) }];

        setChartLabels(chartLabels);
        setChartData(chartData);
      } catch (err) {
        setHasError(true);
        console.error(err);
      }

      setIsLoading(false);
    };

    if (!isLoadingRegionSales && !hasErrorRegionSales) {
      setData();
    }
  }, [sales, isLoadingRegionSales, hasErrorRegionSales]);

  const chartOptions = merge(BaseOptionChart(), {
    tooltip: {
      marker: { show: false },
      y: {
        formatter: (amount) => `${amount} €`,
        title: {
          formatter: () => `Sales`
        }
      }
    },
    plotOptions: {
      bar: { horizontal: true, barHeight: '28%', borderRadius: 2 }
    },
    xaxis: {
      categories: chartLabels
    }
  });

  if (hasError || hasErrorRegionSales) {
    return (
      <Alert severity="error">
        An error occurred while trying to load the regions — Please, try to refresh the page!
      </Alert>
    );
  }

  return (
    <Card>
      <CardHeader title="Country Sales" />
      <Box sx={{ mx: 3 }} dir="ltr">
        {isLoading || isLoadingRegionSales ? (
          <Typography align="center" variant="h3">
            <CircularProgress size={30} color="inherit" />
          </Typography>
        ) : (
          <ReactApexChart type="bar" series={chartData} options={chartOptions} height="auto" />
        )}
      </Box>
    </Card>
  );
}
